module.exports = __webpack_public_path__ + "img/Bronze.3d369490.png";